import type * as React from 'react'
import {connect} from 'react-redux'

import type {State} from '../../../reducers/types'

import SidebarSearch from './SidebarSearch'
import {changeSidebarSearchActive, changeSidebarSearchQuery} from './SidebarSearch.actions'
import type {SidebarSearchOwnProps, StateProps} from './SidebarSearch.types'

export default connect(
  (state: State): StateProps => ({
    searchQuery: state.sidebar.searchQuery,
    searchActive: state.sidebar.searchActive,
  }),
  {
    changeSidebarSearchQuery,
    changeSidebarSearchActive,
  },
)(SidebarSearch) as React.ComponentType<SidebarSearchOwnProps>
